export default "__VITE_ASSET__BNf0IfJ$__"